import { render, staticRenderFns } from "./PrHoldLeft.vue?vue&type=template&id=8f7a76b0&"
import script from "./PrHoldLeft.vue?vue&type=script&lang=js&"
export * from "./PrHoldLeft.vue?vue&type=script&lang=js&"
import style0 from "./PrHoldLeft.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports